import {
    LOADED_CHALLENGE_VERSIONS,
    LOADED_CHALLENGE_VERSIONS_TOTAL,
    LOADED_CHALLENGE_VERSIONS_PAGES,
    LOADED_CHALLENGES_UPDATES,
    LOADED_CHALLENGE_VERSIONS_LIMIT,
    LOADED_CHALLENGE_VERSIONS_CURRENT,
    LOADED_CHALLENGE_VERSION,
    LOADED_CHALLENGE_CODES,
    LOADED_CHALLENGE_RESOURCES,
    LOADED_CHALLENGE_VERSION_STREAM_ENTITIES,
    SET_CHALLENGE_PREVIEW_CURRENT_INDEX,
    SET_CHALLENGE_PREVIEW_SHOW_REMINDER,
    LOADED_MY_SCHOOL_CHALLENGES,
    SET_LIBRARY_SUBJECT,
    SET_LIBRARY_TOPIC,
    SET_LIBRARY_GRADE,
    SET_LIBRARY_MEASURE,
    SET_LIBRARY_THEME
} from "../actions/challenge_actions";

const searchParams = new URLSearchParams(location.search);

const challenge_versions = (payload = [], action) => {
    switch (action.type) {
        case LOADED_CHALLENGE_VERSIONS:
            return action.payload;
        default:
            return payload;
    }
};
const challenge_versions_current = (payload = searchParams.has('current') ? parseInt(searchParams.get('current')) : 1, action) => {
    switch (action.type) {
        case LOADED_CHALLENGE_VERSIONS_CURRENT:
            return action.payload;
        default:
            return payload;
    }
};
const challenge_versions_total = (payload = 0, action) => {
    switch (action.type) {
        case LOADED_CHALLENGE_VERSIONS_TOTAL:
            return action.payload;
        default:
            return payload;
    }
};
const challenge_versions_pages = (payload = 0, action) => {
    switch (action.type) {
        case LOADED_CHALLENGE_VERSIONS_PAGES:
            return action.payload;
        default:
            return payload;
    }
};
const challenge_versions_limit = (payload = searchParams.has('limit') ? parseInt(searchParams.get('limit')) : 25, action) => {
    switch (action.type) {
        case LOADED_CHALLENGE_VERSIONS_LIMIT:
            return action.payload;
        default:
            return payload;
    }
};
const challenge_updates = (payload = null, action) => {
    switch (action.type) {
        case LOADED_CHALLENGES_UPDATES:
            return action.payload;
        default:
            return payload;
    }
};
const challenge_version = (payload = null, action) => {
    switch (action.type) {
        case LOADED_CHALLENGE_VERSION:
            return action.payload;
        default:
            return payload;
    }
};
const challenge_codes = (payload = [], action) => {
    switch (action.type) {
        case LOADED_CHALLENGE_CODES:
            return action.payload;
        default:
            return payload;
    }
};
const challenge_resources = (payload = [], action) => {
    switch (action.type) {
        case LOADED_CHALLENGE_RESOURCES:
            return action.payload;
        default:
            return payload;
    }
};
const challenge_version_stream_entities = (payload = [], action) => {
    switch (action.type) {
        case LOADED_CHALLENGE_VERSION_STREAM_ENTITIES:
            return action.payload;
        default:
            return payload;
    }
};
const challenge_preview_current_index = (payload = 0, action) => {
    switch (action.type) {
        case SET_CHALLENGE_PREVIEW_CURRENT_INDEX:
            return action.payload;
        default:
            return payload;
    }
};
const challenge_preview_show_reminder = (payload = false, action) => {
    switch (action.type) {
        case SET_CHALLENGE_PREVIEW_SHOW_REMINDER:
            return action.payload;
        default:
            return payload;
    }
};
const me_school_challenges = (payload = [], action) => {
    switch (action.type) {
        case LOADED_MY_SCHOOL_CHALLENGES:
            return action.payload;
        default:
            return payload;
    }
};
const library_subject = (payload = 'math', action) => {
    switch (action.type) {
        case SET_LIBRARY_SUBJECT:
            return action.payload;
        default:
            return payload;
    }
};
const library_grade = (payload = '', action) => {
    switch (action.type) {
        case SET_LIBRARY_GRADE:
            return action.payload;
        default:
            return payload;
    }
};
const library_theme = (payload = '', action) => {
    switch (action.type) {
        case SET_LIBRARY_THEME:
            return action.payload;
        default:
            return payload;
    }
};
const library_topic = (payload = '', action) => {
    switch (action.type) {
        case SET_LIBRARY_TOPIC:
            return action.payload;
        default:
            return payload;
    }
};
const library_measure = (payload = 'metric', action) => {
    switch (action.type) {
        case SET_LIBRARY_MEASURE:
            return action.payload;
        default:
            return payload;
    }
};

export default {
    challenge_versions,
    challenge_versions_current,
    challenge_versions_total,
    challenge_versions_pages,
    challenge_versions_limit,
    challenge_updates,
    challenge_version,
    challenge_codes,
    challenge_resources,
    challenge_version_stream_entities,
    challenge_preview_current_index,
    challenge_preview_show_reminder,
    me_school_challenges,
    library_subject,
    library_grade,
    library_theme,
    library_topic,
    library_measure
}
